module.exports = __webpack_public_path__ + "img/img_banner_dwangjing.2553112d.png";